import { h } from 'preact'
import { PureComponent } from 'preact-compat'
import Phrase from '../../../libs/translationsUtils/phrase'

interface Props {
  onReport: () => void
}

class ReportPrivateMessageButton extends PureComponent<Props> {
  render ({ onReport }: Props) {
    return (
      <div className='qa-private-message-report' onClick={onReport}>
        <Phrase p='privateMessages.conversation.reportButton' />
      </div>
    )
  }
}

export default ReportPrivateMessageButton
